import React from 'react';
import 'antd/dist/antd.css'; 
import '../App.css';
import { SendOutlined } from '@ant-design/icons';
import axios from 'axios';

// let parrafo1 = "¡Buen trabajo!";
// let parrafo2 = "Acabamos de enviarle un correo electronico con las instrucciones de pago para obtener el informe!";
// let parrafo3 = "Muchas gracias!";


export default class BuenTrabajo extends React.Component {
  state = {
    parrafos:{}
  }

  componentDidMount() {
    const baseUrl = "https://a3l.com.ar/Cotizador/Backend/DatosPagina/PAGINA_PASO1";
    axios.get(baseUrl)
      .then(res => {
        const parrafos = res.data;
        this.setState({ parrafos });
      })
  }

  render() {
    return (

            <div className="containerPrincipal">
            <div className="containerSecundario">
                <SendOutlined style={{fontSize:"70px", color:"#1890ff"}} /> <br/><br/>
                <h1 className='bold'> { this.state.parrafos.parrafo1}</h1><br/>
                <h2 className='lighter'>{ this.state.parrafos.parrafo2}</h2><br/>
                <br/><h2 className='lighter'>{ this.state.parrafos.parrafo3}</h2><br/><br/><br/>
            </div>
        </div>


    )
  }
}